import { Drawer } from "antd";
import React from "react";

const TmsDrawer = ({
  closable,
  children,
  width,
  visible,
  title,
  onOk,
  onClose,
  centered,
  footer,
  className,
  extra,
}) => {
  return (
    <Drawer
      className={className ?? ""}
      centered={centered}
      width={width}
      closable={closable}
      open={visible}
      title={title}
      onOk={onOk}
      onClose={onClose}
      footer={footer}
      extra={extra}
    >
      {children}
    </Drawer>
  );
};

export default TmsDrawer;
